import API from './api';

export const getPlicanteTokenRequest = () => API({
  method: 'post',
  url: '/plicante/get_user_token',
});

export const getTsooSectionsRequest = () => API({
  method: 'get',
  url: '/tsoo_sections',
});

export const getTsooPermissionsRequest = () => API({
  method: 'get',
  url: '/tsoo_permissions',
});
